<template>
    <router-link to="/challenge/select-user" class="challenge-link-initialize">
        <span class="challenge-link-initialize__heading">Meydan Oku</span>
        <span class="challenge-link-initialize__description">Bir rakibe meydan oku</span>
        <div class="challenge-link-initialize__online-data">
            <span
                v-if="showPreloader"
                class="challenge-link-initialize__preloader"></span>
            <span
                v-if="!showPreloader"
                class="challenge-link-initialize__online-count">{{ onlineCount }} AKTİF</span>
        </div>
        <span class="challenge-link-initialize__deco-triangle"></span>
        <span class="challenge-link-initialize__deco-sword-guy"></span>
    </router-link>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        data(){
            return {
                showPreloader: false,
                onlineCount: 16,
            };
        },

        mounted(){
            // Show preloader for online data.
            this.showPreloader = true;

            fetch(this.$store.state.api.challengeUsersActive, {
                credentials: 'include',
            })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(activeUsers => {
                    this.onlineCount = activeUsers.length;

                    // Hide preloader.
                    this.showPreloader = false;
                })
                .catch(err => {
                    if(err instanceof Error){
                        console.error(`LINK_INITIALIZE/MOUNTED/FETCH_ERROR`);
                        this.$foneturkError({
                            text: this.$t(`error.fetch`),
                        });
                    }
                    else if(err.code === 'CHALLENGE_USERS_ACTIVE_MODEL/USERS_ACTIVE::INV_USER_SESSION'){
                        console.error(`LINK_INITIALIZE/MOUNTED::API_ERROR_01 --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.login`),
                            didClose: () => {
                                // this.$router.push('/login');
                            }
                        });
                    }
                    else if(this.$te(`error.api.challengeUsersActive.${err.code}`)){
                        console.error(`LINK_INITIALIZE/MOUNTED::API_ERROR_02 --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.api.challengeUsersActive.${err.code}`)
                        });
                    }
                    else{
                        console.error(`LINK_INITIALIZE/MOUNTED::UNEXPECTED_API_ERROR --> ${err.code}`);
                        this.$foneturkError({
                            text: this.$t(`error.fetch`),
                        });
                    }
                })
        }
    };
</script>

<style scoped src="@/css/components/challenge-link-initialize.css"></style>